/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_Connect_CalendarInputs */



/**
* | output |
* | --- |
* | "Connect your calendar" |
*
* @param {Empty_Connect_CalendarInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const empty_connect_calendar = /** @type {((inputs?: Empty_Connect_CalendarInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_Connect_CalendarInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Agenda koppelen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecter votre agenda")
	return /** @type {LocalizedString} */ ("Connect your calendar")
});